(() => {
  'use strict';
  const themes = ['christmas', 'halloween', 'nature', 'celebration', 'other'];
  const phases = {preparing:-1, queued:0, moderating:1, generating:2, saving:3, ready:4};
  const terminal = state => ['ready','failed','uncertain'].includes(state);
  function reduce(current, event) {
    if (!event || typeof event.jobId !== 'string' || !/^[a-zA-Z0-9_-]{1,100}$/.test(event.jobId)) return current;
    if (typeof event.status !== 'string' || (!Object.hasOwn(phases, event.status) && !['failed','uncertain'].includes(event.status))) return current;
    if (!current) return {jobId:event.jobId, status:event.status, theme:themes.includes(event.theme) ? event.theme : 'other'};
    if (event.jobId !== current.jobId) {
      return event.start === true && terminal(current.status) ? reduce(null, event) : current;
    }
    if (current.status === 'uncertain' && event.start === true && event.accepted === true) return {...current,status:event.status};
    if (terminal(current.status)) return current;
    if (event.status === current.status) return current;
    if (Object.hasOwn(phases, event.status) && phases[event.status] < phases[current.status]) return current;
    return {...current, status:event.status};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {reduce, themes};
  if (typeof document === 'undefined') return;
  function init(root) {
    if (root.dataset.waitInitialized) return;
    root.dataset.waitInitialized = 'true';
    const card = root.querySelector('[data-dyd-waiting]');
    const copy = JSON.parse(root.querySelector('[data-wait-copy]').textContent);
    const message = root.querySelector('[data-wait-message]');
    const description = root.querySelector('[data-wait-description]');
    const previewLabel = root.querySelector('[data-wait-preview-label]');
    const motion = root.querySelector('[data-wait-motion]');
    const progress=root.querySelector('[data-wait-progress]');
    const phase=root.querySelector('[data-wait-phase]');
    const elapsed=root.querySelector('[data-wait-elapsed]');
    const studio=root.closest('[data-dyd-ai-source]');
    let live=null,timer=null,startedAt=0;
    function stop(){clearInterval(timer);timer=null;}
    function render(state) {
      stop();
      if(!state){card.hidden=true;return;}
      card.hidden=false;card.dataset.theme=state.theme;card.dataset.state=state.status;
      previewLabel.hidden=true;
      message.textContent=state.status==='generating'?copy.generating[state.theme]:(state.status==='preparing'?copy.queued:copy[state.status]);
      description.textContent=['failed','uncertain'].includes(state.status)?copy.failure_note:state.status==='ready'?copy.ready_note:copy.description;
      const active=!terminal(state.status);
      progress.dataset.active=String(active);
      if(state.status==='ready'){progress.setAttribute('aria-valuenow','100');phase.textContent=copy.complete;}
      else {progress.removeAttribute('aria-valuenow');phase.textContent=active?copy.active:copy[state.status];}
      root.querySelectorAll('.dyd-wait__stages li').forEach((li,i)=>{li.dataset.done=String(state.status==='ready'||i<(phases[state.status]||0)-1);li.setAttribute('aria-current',String(i===Math.max(0,(phases[state.status]||0)-1)));});
      const tick=()=>{
        const seconds=Math.floor((Date.now()-startedAt)/1000);
        elapsed.textContent=copy.elapsed.replace('[time]',Math.floor(seconds/60)+':'+String(seconds%60).padStart(2,'0'));
        if(seconds>=120&&active)description.textContent=copy.delay;
        else if(seconds>=60&&active)description.textContent=copy.still;
      };
      tick();if(active)timer=setInterval(tick,1000);
    }
    motion.addEventListener('click',()=>{const paused=card.dataset.paused!=='true';card.dataset.paused=String(paused);motion.setAttribute('aria-pressed',String(paused));motion.textContent=paused?copy.resume:copy.pause;});
    studio.addEventListener('dyd:ai-job-status',event=>{
      if(studio.dataset.authState!=='signed-in')return;
      const detail=event.detail;
      const preparing=detail?.status==='preparing'&&detail.start===true;
      if(!live&&detail?.accepted!==true&&!preparing)return;
      if(live?.status==='preparing'&&detail?.accepted===true&&detail.start===true)live=null;
      const next=reduce(live,event.detail);if(next===live)return;
      if(!live||next.jobId!==live.jobId)startedAt=Date.now();
      live=next;render(live);
    });
    studio.addEventListener('dyd:ai-session-ended',()=>{stop();live=null;card.hidden=true;});
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) stop();
    });
  }
  function initAll() { document.querySelectorAll('[data-dyd-waiting-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
